export default __webpack_public_path__ + "static/media/Order_management.bd8cb251.png";